// extracted by mini-css-extract-plugin
export default {"section":"image-with-text_section__IdAKQ","htmlContent":"image-with-text_htmlContent__abmpm"};